import {useEffect, useState} from 'react';

const prepareSize = () => ({width: window.innerWidth, height: window.innerHeight});
const checkIsMobile = ({width} = prepareSize()) => width <= 768;

export function useWindowSize({triggerResize} = {}) {
  const [fetched, setFetched] = useState(false);
  const [windowSize, setWindowSize] = useState(prepareSize());
  const [isMobile, setIsMobile] = useState(checkIsMobile());

  useEffect(() => {
    setTimeout(() => {
      setFetched(true);
    }, 200);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowSize(prepareSize());
      setIsMobile(checkIsMobile());
      triggerResize && triggerResize();
    }
    if (fetched) window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [fetched]);

  return {...windowSize, isMobile};
}
